export default __webpack_public_path__ + "static/media/tick-blue.4f759f5f.svg";